import { render } from "./icon-detail-sender.vue?vue&type=template&id=3e6e52b9"
import script from "./icon-detail-sender.vue?vue&type=script&lang=js"
export * from "./icon-detail-sender.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__